export default __webpack_public_path__ + "static/media/logo.d014bf13.png";